import { Colors } from '../../../../colors';

export const defaultStyleText: any = {
  'fontFamily': 'EncodeSans-Medium',
  'color': Colors.Black,
  'fontSize': '14px',
  'textAlign': 'left'
};
